'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Input$Genetics = require("./Input.bs.js");
var Output$Genetics = require("./Output.bs.js");
var NASelect$Genetics = require("./NASelect.bs.js");
var ColorToggle$Genetics = require("./ColorToggle.bs.js");
var NucleicAcid$Genetics = require("./NucleicAcid.bs.js");

function Dashboard(Props) {
  var match = React.useState((function () {
          return /* DNA */1;
        }));
  var setBaseType = match[1];
  var baseType = match[0];
  var updateBaseType = function (e) {
    var value = e.target.value;
    var newBaseType = NucleicAcid$Genetics.from_string(value);
    return Curry._1(setBaseType, (function (param) {
                  return newBaseType;
                }));
  };
  var match$1 = React.useState((function () {
          return [];
        }));
  var setStrand = match$1[1];
  var strand = match$1[0];
  var updateStrand = function (e) {
    var value = e.target.value.toUpperCase().split("");
    return Curry._1(setStrand, (function (param) {
                  return value;
                }));
  };
  var match$2 = React.useState((function () {
          return true;
        }));
  var colorBases = match$2[0];
  return React.createElement(React.Fragment, undefined, React.createElement(Input$Genetics.make, {
                  strand: strand,
                  onChange: updateStrand,
                  children: null
                }, "Enter the ", React.createElement(NASelect$Genetics.make, {
                      value: baseType,
                      onChange: updateBaseType
                    }), " template strand", React.createElement("br", undefined), React.createElement(ColorToggle$Genetics.make, {
                      setToggle: match$2[1],
                      toggle: colorBases
                    })), React.createElement(Output$Genetics.make, {
                  strand: strand,
                  baseType: baseType,
                  colorBases: colorBases
                }));
}

var make = Dashboard;

exports.make = make;
/* react Not a pure module */
